export enum SUPPORTED_MANUAL_TRANSLATIONS {
  EN_CA = 'en-CA',
  FR_CA = 'fr-CA',
  ES_MX = 'es-MX',
  PT_PT = 'pt-PT'
}
